import { SHARED_EXPORT_OPTIONS } from './types';

export const COMPANY_EXPORT_OPTIONS = {
  VALUATION: 'valuation',
  VALUATION_SUMMARY: 'valuationSummary',
  ...SHARED_EXPORT_OPTIONS,
} as const;

export const FUND_EXPORT_OPTIONS = {
  FUND: 'fund',
  FUND_SUMMARY: 'fundSummary',
  ...SHARED_EXPORT_OPTIONS,
} as const;

export const FIRM_EXPORT_OPTIONS = {
  // FIRM_SUMMARY includes a page for the firm summary, a page for the aggregated Admin report, a page for the Admin report detailed,
  // and a summary for each fund
  FIRM_SUMMARY: 'firmSummary',
  PORTFOLIO_COMPANIES: 'portfolioCompanies',
} as const;

export type CompanyExportOption = (typeof COMPANY_EXPORT_OPTIONS)[keyof typeof COMPANY_EXPORT_OPTIONS];
export type FundExportOption = (typeof FUND_EXPORT_OPTIONS)[keyof typeof FUND_EXPORT_OPTIONS];
export type FirmExportOption = (typeof FIRM_EXPORT_OPTIONS)[keyof typeof FIRM_EXPORT_OPTIONS];

export const BULK_EXPORT_APP_BAR_TITLE = 'Bulk Excel Export';
export const BULK_EXPORT_APP_BAR_SUBTITLE = 'This will export all the data for the funds and companies you select';
export const BULK_EXPORT_APP_BAR_ACTION_LABEL = 'EXPORT';

export const NOT_STARTED_VALUE = 0;
export const WAITING_PICK_UP_VALUE = 1;
export const IN_PROGRESS_VALUE = 2;
export const COMPLETED_VALUE = 3;
export const FAILED_VALUE = 4;
export const NOT_STARTED_LABEL = 'Not Started';
export const WAITING_PICK_UP_LABEL = 'Waiting for Processing';
export const IN_PROGRESS_LABEL = 'In Progress';
export const COMPLETED_LABEL = 'Completed';
export const FAILED_LABEL = 'Failed';

export const REPORT_STATUSES: Record<number, string> = {
  [NOT_STARTED_VALUE]: NOT_STARTED_LABEL,
  [WAITING_PICK_UP_VALUE]: WAITING_PICK_UP_LABEL,
  [IN_PROGRESS_VALUE]: IN_PROGRESS_LABEL,
  [COMPLETED_VALUE]: COMPLETED_LABEL,
  [FAILED_VALUE]: FAILED_LABEL,
};
export const ACCEPT_STATUS_CODE = 202;
export const NOT_FOUND_STATUS_CODE = 404;
